import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import ProductId from "../../components/ProductId/ProductId";
import Navbar from "../../components/Home/navbar/Navbar";
import { productIdApi } from "../../Apis/ProductApi";
import { getStoresApi } from "../../Apis/StoreApi";

const ProductIdPage = ({ data }) => {
  const { productId } = useParams();
  const [productData, setProductData] = useState({});
  const [storeDetails, setStoreDetails] = useState({});
  const [firstImage, setFirstImage] = useState("");

  const scrollToTop = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productResponse = await productIdApi(productId);
        if (productResponse && productResponse?.products) {
          setProductData(productResponse?.products);
          await getStoreDetails(productResponse.products?.storeID);
          setFirstImage(productResponse.products?.images[0]);
        } else {
          console.error("Error fetching product data:", productResponse);
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    fetchData();
    scrollToTop.current.scrollIntoView({ behavior: "smooth" });
  }, [productId]);

  const getStoreDetails = async (storeID) => {
    try {
      const storeResponse = await getStoresApi(storeID);
      if (storeResponse && storeResponse?.store) {
        setStoreDetails(storeResponse.store);
      } else {
        console.error("Error fetching store details:", storeResponse);
      }
    } catch (error) {
      console.error("Error fetching store details:", error);
    }
  };

  return (
    <div ref={scrollToTop}>
      <div className="sticky top-0 z-30">
        <Navbar />
      </div>
      <ProductId
        productData={productData}
        firstImage={firstImage}
        storeDetails={storeDetails}
      />
    </div>
  );
};

export default ProductIdPage;
